var MpPageNewsletters;

(function() {
    if (!document.querySelector('#vue-newsletters')) {
        return;
    }

    MpPageNewsletters = new Vue({
        el: '#vue-newsletters',
        mixins: [MpStaticPage],

        data: {
            year: 0,
        },

        methods:{

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.year = parseInt(this.$refs.yearSelector.getAttribute('data-year'));
            },

            setYear: function(year) {
                this.year = year;
            },

            isYearSelected: function(newsletterYear) {
                return newsletterYear === this.year;
            },
        },

    });

})();
